let callbacks = [];

function loadedTinymce() {
  // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2144
  // check is successfully downloaded script
  return window.tinymce;
}

/**
 * 带重试机制的动态脚本加载器
 * @param {string} src - 脚本URL
 * @param {function} callback - 回调函数
 * @param {number} maxRetries - 最大重试次数，默认3次
 * @param {number} retryDelay - 重试延迟（毫秒），默认1000ms
 */
const dynamicLoadScript = (src, callback, maxRetries = 3, retryDelay = 1000) => {
  const cb = callback || function () {};

  // 处理加载错误，决定是否重试
  function handleLoadError(retriesLeft, script) {
    // 移除失败的 script 标签
    if (script && script.parentNode) {
      script.parentNode.removeChild(script);
    }

    if (retriesLeft > 0) {
      console.warn(`TinyMCE load failed, retrying in ${retryDelay}ms... Retries left: ${retriesLeft}`);
      setTimeout(() => {
        loadWithRetry(retriesLeft - 1);
      }, retryDelay);
    } else {
      // 重试次数用完，返回错误
      const error = new Error(`Failed to load ${src} after ${maxRetries} retries`);
      cb(error);
    }
  }

  // 内部重试函数
  function loadWithRetry(retriesLeft) {
    // 先清理之前可能失败的 script 标签
    const existingScript = document.getElementById(src);
    if (existingScript) {
      existingScript.remove();
    }

    // 如果 tinymce 已经加载成功，直接回调
    if (loadedTinymce()) {
      cb(null);
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.id = src;
    document.body.appendChild(script);

    script.onload = function () {
      this.onerror = this.onload = null;
      // 验证 tinymce 是否真正加载成功
      if (loadedTinymce()) {
        for (const fn of callbacks) {
          fn(null, script);
        }
        callbacks = [];
      } else {
        // 脚本加载了但 tinymce 对象不存在，视为失败
        handleLoadError(retriesLeft, script);
      }
    };

    script.onerror = function () {
      this.onerror = this.onload = null;
      handleLoadError(retriesLeft, script);
    };
  }

  // 检查是否已有正在加载的 script
  const existingScript = document.getElementById(src);

  if (existingScript && loadedTinymce()) {
    // 已经加载成功
    cb(null, existingScript);
    return;
  }

  if (existingScript && !loadedTinymce()) {
    // script 标签存在但 tinymce 未加载成功，可能正在加载中或已失败
    // 将回调加入队列
    callbacks.push(cb);
    return;
  }

  // 首次加载
  callbacks.push(cb);
  loadWithRetry(maxRetries);
};

export default dynamicLoadScript;
